import { initializeWorkleapAi, type Environment, type WorkleapAiClient } from "@workleap-ai/client/react";
import type { RootLogger } from "@workleap/logging";
import type { AppEnvironmentValue } from "./env.ts";

const environmentByAppEnv = {
    local: "staging",
    msw: "msw",
    stg: "staging",
    prod: "production"
} as const satisfies Record<AppEnvironmentValue, Environment>;

export function initializeWorkleapAiClient(appEnv: AppEnvironmentValue, verbose: boolean, loggers: RootLogger[]): WorkleapAiClient {
    return initializeWorkleapAi("wlp", environmentByAppEnv[appEnv], { verbose, loggers });
}
